var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warp-tree",style:({width:_vm.width+"px"})},[_c('Treeselect',{attrs:{"multiple":false,"options":_vm.options,"clearable":false,"normalizer":_vm.normalizer,"show-count":true,"placeholder":_vm.placeholder},on:{"select":_vm.selectBtn},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }